import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "neuronest-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
    // Disable PostHog if it exists
    if (window.posthog) {
      window.posthog.opt_out_capturing();
    }
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
    >
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.12)] border border-[#E7E9EC] p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-9 h-9 rounded-xl bg-brand-peach/15 flex items-center justify-center flex-shrink-0 mt-0.5">
            <Cookie size={18} className="text-[#D4956A]" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-sm text-[#2F3A56] font-medium mb-1">
              We use cookies to understand how you use our site
            </p>
            <p className="text-xs text-[#5A6376] leading-relaxed">
              We use analytics cookies to improve your experience. No
              advertising, no tracking across sites.{" "}
              <a
                href="/privacy"
                className="text-brand-teal hover:underline"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
        <div className="flex gap-2 w-full sm:w-auto flex-shrink-0">
          <Button
            data-testid="cookie-decline"
            variant="outline"
            onClick={handleDecline}
            className="rounded-full border-[#E7E9EC] text-[#5A6376] hover:bg-[#F0F1F3] text-xs px-4 py-2 h-auto flex-1 sm:flex-none"
          >
            Decline
          </Button>
          <Button
            data-testid="cookie-accept"
            onClick={handleAccept}
            className="rounded-full bg-brand-teal hover:bg-brand-teal/90 text-white text-xs px-4 py-2 h-auto flex-1 sm:flex-none"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
